import { useEffect, useRef, useState } from 'react';

import { t } from 'i18next';

import Dropdown from 'shared/components/ui/DropDown/DropDown';

import ArrowIcon from 'assets/arrow.svg?react';

export interface ISelectOption {
  value: string | number;
  label: string;
  tooltip?: string;
}

interface ISelectProps {
  options: ISelectOption[];
  selectedOption: ISelectOption;
  onSelect: (option: ISelectOption) => void;
  className?: string;
  disabled?: boolean;
}

const Select = ({ options, selectedOption, onSelect, className, disabled }: ISelectProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectRef = useRef<HTMLDivElement>(null);

  const handleOpenMenu = () => {
    if (disabled) return;
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (option: ISelectOption) => {
    setIsOpen(false);
    onSelect(option);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (selectRef.current && !selectRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div ref={selectRef} className={`relative ${className}`}>
      <div
        className={`flex items-center justify-center rounded-lg border border-indigo px-3 py-2 text-[14px] font-medium leading-[18px] text-white focus:border-transparent focus:outline-none sm:py-3 md:rounded-xl md:border-2 md:py-[14.5px] md:text-[20px] md:leading-[27px] ${
          disabled ? 'pointer-events-none bg-gray' : 'cursor-pointer bg-border'
        }`}
        onClick={handleOpenMenu}
      >
        <span className="mr-3">
          {selectedOption ? selectedOption.label : t('modals.setBet.selectAnOption')}
        </span>

        <ArrowIcon
          className={`color-white w-2.5 transform transition-transform md:w-3 ${
            isOpen ? 'rotate-180' : ''
          } `}
        />
      </div>
      <Dropdown
        open={isOpen}
        list={options}
        position={{ top: 58, right: 0 }}
        onClick={handleOptionClick}
      />
    </div>
  );
};

export default Select;
